<template>
<b-row class="m-2">
    <b-col v-if="loaded === false">
        <template>
            <div class="OTloading">
                <div class="OTloader"></div>
            </div>
        </template>
    </b-col>
    <b-col v-else>
        <b-row>
            <b-col>
                <h1>{{ecmResourceStrings.ttlRepositoryTypeDefinitionAttribute}} '{{typename}}'</h1>
            </b-col>
        </b-row>
        <b-row>
            <b-col >
                <otif-ecm-table-info
                    ref="table"
                    :sortCallback="sort"
                    :totalRowsCallback="totalRows"
                    :rows="defAttributes"
                    :paginated="false"
                    :columns="columns">
                    <template slot="empty">
                        {{ecmResourceStrings.msgNoInfo}}
                    </template>
                </otif-ecm-table-info>
            </b-col>
        </b-row>
    </b-col>
</b-row>
</template>

<script>

import ecmRepositoryDefinition from '@/ecm/collections/ecmrepodefinitions.js';
import { sortOn } from '../../../utils/commonECM.js';

export default {
   
    props: {
        typename: {
            required: true
        }
    },

    data() {
        return {
            ecmResourceStrings: require('../../../utils/resourceECM.js'),  
            ecmRepositoryDefinition: new ecmRepositoryDefinition({paginated: false, name: this.typename}),
            columns: [
            {
                name: 'name',
                label: 'Name',
                sortable: true,
                editable:false,
                render(row) {
                    return row.name;
                }
            },{
                name: 'type',
                label: 'Type',
                sortable: true,
                editable:false,
                render(row) {
                    return row.type;
                }
            },{
                name: 'minoccur',
                label: 'Min Occurs',
                sortable: false,
                editable:false,
                render(row) {
                    return row.minoccur;
                }
            },{
                name: 'maxOccurs',
                label: 'Max Occurs',
                sortable: false,
                editable:false,
                render(row) {
                    return row.maxoccur;
                }
            },{
                name: 'description',
                label: 'Description',
                sortable: true,
                editable:false,
                render(row) {
                    return row.description;
                }
            },{
                name: 'minvalue',
                label: 'Min Value',
                sortable: false,
                editable:false,
                render(row) {
                    return row.minvalue;
                }
            },{
                name: 'maxvalue',
                label: 'Max Value',
                sortable: false,
                editable:false,
                render(row) {
                    return row.maxvalue;
                }
            },{
                name: 'allowedvalues',
                label: 'Allowed Values',
                sortable: false,
                editable:false,
                render(row) {
                    return row.allowedvalues;
                }
            },{
                name: 'defaultvalues',
                label: 'Default Values',
                sortable: false,
                editable:false,
                render(row) {
                    return row.defaultvalues;
                }
            }],
            loaded: false
        }
    },

    computed: {
        defAttributes() {
            return this.config;
        }
    },

    methods: {
        refresh(){
            this.loaded = true;
        },

        sort(colNumber, dir) {
            var that = this;
            that.sortDir = dir;
            if(colNumber == 0)
                that.config.sort(sortOn('name', dir));
            else if(colNumber == 1)
                that.config.sort(sortOn('type', dir));
            else if(colNumber == 4)
                that.config.sort(sortOn('description', dir));
        },
        totalRows() {
            return this.config.length;
        }
    },
    
    mounted() {

         var breadcrumbs = [{
            name: 'settings',
            meta: { label: 'Settings' }
        },{
            name: 'ecm-repo-types',
            meta: { label: 'Connectors' }
        }
        ,{
            name: 'ecm-type-attr',
            meta: { label: 'Connector Definition Attributes' }
        }];

        this.$store.commit('breadcrumbs', breadcrumbs);
    },
   
    created() {
        var that = this;
        const CONFIG_NAME = 'name';
        const CONFIG_TYPE = 'type';
        const CONFIG_MINVALUE = 'minValue';
        const CONFIG_MAXVALUE = 'maxValue';
        const CONFIG_DEFVALUE = 'defaultValue';
        const CONFIG_MINOCCURS = 'minOccurs';
        const CONFIG_MAXOCCURS = 'maxOccurs';
        const CONFIG_DESCRIPTION = 'description';
        const CONFIG_ALLOWEDVALUE = 'allowedValues';
        that.ecmRepositoryDefinition.fetch({"Content-Type": "application/json; charset=UTF-8"})
            .then(() => {
                that.config=[];
                if(that.ecmRepositoryDefinition.resources)
                {
                    for (let i = 0; i < that.ecmRepositoryDefinition.resources.length; i++) {
                        //const fullParamName = that.ecmRepositoryDefinition.resources[i].attributes.name;
                        const oneelement= that.ecmRepositoryDefinition.resources[i];
                        if(oneelement)
                        {
                            const strName = oneelement.attributes[CONFIG_NAME];
                            const namesArray = strName.split(".");
                            var onename = false;
                            var parametername = false;
                            var jobname = false;
                            var jobparams = false;
                            var foldername = false;
                            var paramName = '';
                            const lennames = namesArray.length;
                            if(lennames == 1)
                            {
                                onename = true;
                            }
                            else
                            {
                                if (namesArray[0] == "repoParam")
                                {
                                    parametername = true;
                                    paramName = namesArray[1]; 
                                }
                                else if (namesArray[0] == "repoPartitionTask")
                                {
                                    jobparams = true;
                                    paramName = namesArray[1]; 
                                }
                                else if (namesArray[0] == "repoPartition")
                                {
                                    jobname = true;
                                    paramName = namesArray[1]; 
                                }
                                else if (namesArray[0] == "repoExcludedFolder")
                                {
                                    foldername = true;
                                    paramName = namesArray[1]; 
                                }
                            }
                            const strType = oneelement.attributes[CONFIG_TYPE];
                            
                            var strMinVal = oneelement.attributes[CONFIG_MINVALUE];
                            if(strMinVal == null)
                                strMinVal = '';
                            
                            var strMaxVal = oneelement.attributes[CONFIG_MAXVALUE];
                            if(strMaxVal == null)
                                strMaxVal = '';
                            
                            var strDefVal = oneelement.attributes[CONFIG_DEFVALUE];
                             if(strDefVal == null)
                                strDefVal = '';
                            
                            var strMin = oneelement.attributes[CONFIG_MINOCCURS];
                            if(strMin == null)
                                strMin = '';
                                                        
                            var strMax = oneelement.attributes[CONFIG_MAXOCCURS];
                            if(strMax == null)
                                strMax = '';
                            
                            var strDesc = oneelement.attributes[CONFIG_DESCRIPTION];
                            if(strDesc == null)
                                strDesc = '';
                            
                            var strAllVal = oneelement.attributes[CONFIG_ALLOWEDVALUE];
                            if(strAllVal == null)
                                strAllVal = '';
                            if(onename == false && parametername == true)
                            {
                                that.config.push({ name: paramName, type:strType, minoccur : strMin, 
                                maxoccur: strMax, description : strDesc, minvalue : strMinVal, maxvalue : strMaxVal,
                                allowedvalues : strAllVal, defaultvalues : strDefVal});  
                            }
                        }
                    }
                }
                that.loaded = true;
            }
    
        )
        .catch((err) => {
            this.$snotify.clear();
            if(err.message)
            {
                this.$snotify.error(err.message, this.ecmResourceStrings.txtError);
            }
            else  if(err.response)
            {
                this.$snotify.error(err.response.data, this.ecmResourceStrings.txtError);
            }
            this.loaded = true;
        });
    },
}

</script>
